module.exports = __webpack_public_path__ + "static/img/performance04.38df3b84.jpg";